import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { formatDate, startOfYear } from '~/utils/date';
import { z } from 'zod';

/** Parses a comma-separated id list (e.g. "1,4,7") from the URL into numbers. */
const idListSchema = z
  .string()
  .optional()
  .transform(v => (v ? v.split(',').map(Number) : []));

export const querySchema = z
  .object({
    search: z.string().default(''),
    districts: idListSchema,
    clubs: idListSchema,
    current_age_categories: z
      .string()
      .optional()
      .transform(v => v === 'true'),
    competition_type_id: z
      .string()
      .default('1')
      .transform(v => Number(v)),
    age_category_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    weight_class_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    from_date: z.string().optional().default(formatDate(startOfYear(), 'yyyy-mm-dd')),
    discipline: z.string().optional().default('points'),
    sex: z.enum(['ALL', 'F', 'M']).default('ALL'),
    to_date: z.string().optional(),
  })
  .merge(paginationSchema);

export type QuerySchema = z.infer<typeof querySchema>;
